import React from 'react';

const NewHampshire = () => (
  <svg
    width="22"
    height="47"
    viewBox="0 0 22 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.55961 46.1555C0.349001 43.8954 1.70071 40.3398 1.02486 35.9181C0.869977 34.9183 -0.0100069 33.5805 0.00407336 32.8483C0.0533544 29.7855 2.16538 26.2087 2.05274 23.1178C2.01754 22.1532 1.62328 20.8928 1.03191 20.0479C1.14455 18.6398 2.84827 18.33 3.59453 17.485C4.46751 16.4852 4.64349 15.4221 5.64319 14.4152C3.93948 10.592 3.54524 5.48737 5.12928 1.1009C6.41058 1.16427 6.73445 2.07958 7.17798 0.586914C9.75467 6.69841 11.5288 13.6126 13.8309 20.5549C14.1688 21.5758 14.4364 22.984 14.8588 24.1387C15.1615 24.9766 16.1471 25.8637 16.3935 26.7016C16.7314 27.8422 16.3865 29.2504 16.9074 30.2854C18.4563 33.3622 22.4832 34.4536 21.5117 38.4739C18.4915 38.6992 17.879 41.3255 16.3935 43.0787C11.4865 43.818 7.29762 45.2614 2.55961 46.1555Z"
      fill="#FC374D"
    />
  </svg>
);

export default NewHampshire;
